import { createAsyncThunk } from "@reduxjs/toolkit";

import * as URL from "../../helpers/url_helper";

import { get, post, put, del } from "../../helpers/api_helper";

export const getGift = createAsyncThunk(
  "getGift",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.GET_GIFT, data);
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      callback && callback(error?.data?.message || error.message || error);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const addGift = createAsyncThunk(
  "addGift",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.ADD_GIFT, data);
      callback && callback(null, response);
      return response;
    } catch (error) {
      callback && callback(error?.data?.message || error.message || error);
      return Thunk.rejectWithValue(error);
    }
  }
);
export const editGift = createAsyncThunk(
  "editGift",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await put(URL.EDIT_GIFT + data?._id, data);
      callback && callback(null, response);
      return response;
    } catch (error) {
      callback && callback(error.message, null);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const deleteGift = createAsyncThunk(
  "deleteGift",
  async ({ data, callback }, thunkAPI) => {
    console.log(data, "data++=++++++++++++++++++++");
    try {
      const response = await del(URL.DELETE_GIFT + data);
      console.log(data, "data----------->");
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");

      return thunkAPI.rejectWithValue(error);
    }
  }
);
